import { useInfiniteQuery, useQuery, useMutation } from '@tanstack/react-query';
import { requestOTP, validateOTP } from '../api/register';
import { getUserInfo } from '../api/user';

export const useGetUser = ({ enabled, ...params }) => {
  return useQuery({
    queryKey: ['userList', params],
    queryFn: ({ signal }) => getUserInfo(params, signal),
    enabled,
    staleTime: 0,
    cacheTime: 0,
    gcTime: 0,
  });
};

export const useGetUserInfinite = ({ enabled, ...params }) => {
  return useInfiniteQuery({
    queryKey: ['userListInfinite', params, enabled],
    queryFn: ({ pageParam = 1, signal }) => getUserInfo({ ...params, page: pageParam }, signal),
    getNextPageParam: (lastPage) => {
      const currentPage = lastPage?.Data?.page;
      const totalPages = lastPage?.Data?.total_pages;

      if (currentPage < totalPages) return currentPage + 1;
      return undefined;
    },
    staleTime: 1000 * 60 * 5,
    enabled: enabled,
  });
};

export const useRequestOtp = () => {
  return useMutation({
    mutationFn: (dto) => requestOTP(dto),
  });
};

export const useVerifyOtp = () => {
  return useMutation({
    mutationFn: (dto) => validateOTP(dto),
  });
};
